import { SVG, Text } from '@svgdotjs/svg.js'

class SvgTextArea {
  constructor(text, options, node) {
    this.text = text
    this.svg = SVG()
    const {
      width = 300,
      height = 100,
      fontSize = 16,
      color = '#000',
      backgroundColor = '',
      strokeColor = '',
      strokeWidth = fontSize * 0.2,
      anchor = 'start',
      leading = 1.5,
    } = options
    this.options = {
      width,
      height,
      fontSize,
      color,
      backgroundColor,
      strokeColor,
      strokeWidth,
      anchor,
      leading,
    }
    if (node) {
      this.addTo(node)
      this.generate()
    }
  }

  generate() {
    const {
      width,
      height,
      fontSize,
      color,
      backgroundColor,
      strokeColor,
      strokeWidth,
      anchor,
      leading,
    } = this.options
    const draw = this.svg.size(width, height)
    if (backgroundColor) {
      draw.rect('100%', '100%').fill(backgroundColor)
    }

    const result = []
    const setStyle = (text) => {
      text.font({
        size: fontSize,
        anchor,
        weight: 200,
      })
      // .stroke({ width: strokeWidth, color: strokeColor})
      .stroke({ width: fontSize*0.2, color: strokeColor})
      .fill(color)
      .leading(leading)
      .attr('paint-order', 'stroke')
      .attr('stroke-linecap', 'round')
      .attr('stroke-linejoin', 'round')
    }
    // 改行位置を計算する
    const svgText = new Text()
    svgText.text((add) => {
      setStyle(add)
      this.text.split('').forEach((t) => {
        add.tspan(t)
        const box = add.bbox()
        if (t === '\n' || box.width > width) {
          const value = add.node.textContent
          result.push(value.slice(0, -1))
          add.clear()
          if (t !== '\n') {
            add.tspan(value.slice(-1))
          }
        }
      })
      result.push(add.node.textContent)
    })

    const ax = (() => {
      switch (anchor) {
        case 'middle':
          return width / 2
        case 'end':
          return width
        default:
          return 0
      }
    })()
    const ay = fontSize * 1.12 // 補正値

    const drawText = draw.text(result.join('\n'))
      .amove(ax, ay)
    setStyle(drawText)
  }

  addTo(node) {
    this.svg.addTo(node)
    this.clear()
    this.generate()
  }

  clear() {
    this.svg.clear()
  }
}

export default SvgTextArea
